'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 *
 * Usage:
 *
 * ```Javascript
 * <Tab isActive isDisabled isVertical>
 *   { Children }
 * </tab>
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} isActive Renders the tab as active.
 * @property {Boolean} isDisabled Render the tab as disabled.
 * @property {Boolean} isVertical Renders the tab as part of a vertical/horizontal navigation tabs.
 */
class Tab extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName (isActive, isDisabled, isVertical) {
    return classNames({
      'Tabs-tab': true,
      'Tabs-tab--vertical': isVertical,
      'is-active': isActive,
      'is-disabled': isDisabled
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, isActive, isDisabled, isVertical, ...otherProps } = this.props;
    return (
      <a {...otherProps} className={this.getClassName(isActive, isDisabled, isVertical)}>
        { children }
      </a>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Tab component
 */
Tab.propTypes = {
  isActive: React.PropTypes.bool,
  isDisabled: React.PropTypes.bool,
  isVertical: React.PropTypes.bool
};

Tab.defaultProps = {
  isActive: false,
  isDisabled: false,
  isVertical: false
};

export default Tab;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/tabs/tab.jsx